var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "q-card",
        [
          _c("q-card-title", [
            _vm._v("\n\t\t\t" + _vm._s(_vm.title) + "\n\t\t")
          ]),
          _c("q-card-separator"),
          _c("q-card-main", [
            _c("div", { staticClass: "q-ma-sm" }, [
              _vm._v("\n\t\t\t\t" + _vm._s(_vm.description) + "\n\t\t\t")
            ]),
            _c("div", { staticClass: "q-ma-sm" }, [
              _vm._v(
                "\n\t\t\t\t" +
                  _vm._s(
                    _vm.$t("stream_type") +
                      ": " +
                      _vm.getLiveClassPlatformTypes(_vm.platform_type)
                  ) +
                  "\n\t\t\t"
              )
            ]),
            _vm.$q.platform.is.mobile
              ? _c("div", { staticClass: "q-ma-sm text-body2" }, [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(_vm.$t("mobile_live_class_instructor_helper")) +
                      "\n\t\t\t"
                  )
                ])
              : _vm._e(),
            _c(
              "div",
              { staticClass: "q-mt-md q-pa-md text-center" },
              [
                _c(
                  "q-btn",
                  {
                    attrs: { color: "primary", disable: _vm.joinClassDisabled },
                    on: {
                      click: function($event) {
                        _vm.platform_type === "jitsi"
                          ? (_vm.show_modal_class_room = true)
                          : _vm.openMeeting()
                      }
                    }
                  },
                  [
                    _c("q-icon", {
                      attrs: {
                        left: "",
                        size: "3em",
                        name: "fas fa-chalkboard"
                      }
                    }),
                    _c("div", { staticClass: "q-pa-sm" }, [
                      _vm._v(_vm._s(_vm.$t("start_live_class")))
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm.show_modal_class_room
        ? _c(
            "q-modal",
            {
              attrs: {
                "content-css": { minWidth: "100vw", minHeight: "100vh" },
                "no-backdrop-dismiss": "",
                "no-esc-dismiss": "",
                maximized: ""
              },
              model: {
                value: _vm.show_modal_class_room,
                callback: function($$v) {
                  _vm.show_modal_class_room = $$v
                },
                expression: "show_modal_class_room"
              }
            },
            [
              _c(
                "q-modal-layout",
                [
                  _c(
                    "q-toolbar",
                    { attrs: { slot: "header" }, slot: "header" },
                    [
                      _c("q-btn", {
                        attrs: {
                          flat: "",
                          round: "",
                          dense: "",
                          icon: "fas fa-times"
                        },
                        on: {
                          click: function($event) {
                            return _vm.hideModalClassRoom()
                          }
                        }
                      }),
                      _c("q-toolbar-title", [
                        _vm._v(
                          "\n\t\t\t\t\t" + _vm._s(_vm.title) + "\n\t\t\t\t"
                        )
                      ])
                    ],
                    1
                  ),
                  _vm.show_modal_class_room
                    ? _c("class-room", {
                        attrs: { room: _vm.room, title: _vm.title },
                        on: { hideModalClassRoom: _vm.hideModalClassRoom }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "q-dialog",
        {
          attrs: { "stack-buttons": "", "prevent-close": "" },
          on: {
            cancel: function($event) {
              _vm.show_meet_dialog = false
            },
            hide: function($event) {
              _vm.show_meet_dialog = false
            }
          },
          model: {
            value: _vm.show_meet_dialog,
            callback: function($$v) {
              _vm.show_meet_dialog = $$v
            },
            expression: "show_meet_dialog"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("window_blocked")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(
              "\n\t\t\t" +
                _vm._s(_vm.$t("browser_window_blocked_click")) +
                "\n\t\t\t"
            ),
            _c(
              "a",
              {
                attrs: {
                  href: _vm.meet_external_url,
                  target: "_blank",
                  rel: "noopener noreferrer"
                }
              },
              [_vm._v(_vm._s(_vm.$t("here")))]
            ),
            _vm._v(
              "\n\t\t\t" + _vm._s(_vm.$t("to_access_the_class")) + "\n\t\t"
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }